<template>
  <div>
    <v-overlay :z-index="5000" :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="dialog" max-width="700px">
      <v-card flat tile id="Top_Scroll">
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="font-weight-bold">
            <v-icon class="mr-2">edit</v-icon>업체물품 반입신청사항 수정
          </v-toolbar-title>
        </v-toolbar>
        <v-divider class="ml-4 mr-4"></v-divider>

        <v-card outlined tile class="ma-4">
          <v-card-text class="mt-2 mb-2 pb-0">
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.cBizCode" label="사업자등록번호" dense disabled persistent-placeholder></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-if="editedItem.cLocal == 'Y'" v-model="editedItem.cCorpNmKor" label="업체명" dense disabled persistent-placeholder></v-text-field>
                <v-text-field v-else v-model="editedItem.cCorpNmEng" label="업체명" dense disabled persistent-placeholder></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="CustomInfo.CustomNm" label="이름" dense disabled persistent-placeholder></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="CustomInfo.Tel" label="전화번호" dense disabled persistent-placeholder></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card outlined tile class="ma-4 essetial_card">
          <v-card-text class="mt-2 mb-2 pb-0">
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-select v-model="editedItem.cLabel" @change="zCorCarryItemInfo = [];AddRow(editedItem.cLabel);" :items="zCarryItem" class="essetial_input" dense persistent-placeholder>
                  <template v-slot:label>
                    반입물품 분류<strong class="red--text">*</strong>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-radio-group v-model="editedItem.cSort" @change="DisableSelect()" dense mandatory row class="mt-0" style="min-width:220px;">
                  <v-radio value="1" label="반입/반출"></v-radio>
                  <v-radio value="2" label="반입/미반출"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <IronDate ref="IronDateRef" v-model="editedItem.sNowSelectDate" @update="onDateRangeChange" @overmaxperiod="overmaxperiod" cLabelEs="반입/반출 예정일" :bSelect="editedItem.cSort == '2'?true :false" :sMinDate="sToday" style="width:100%"/>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.cZone" @click:append-outer="ShowMapDialog()" append-outer-icon="map" class="essetial_input" dense readonly persistent-placeholder>
                  <template v-slot:label>
                    반입건물<strong class="red--text">*</strong>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.cReason" class="essetial_input" dense persistent-placeholder>
                  <template v-slot:label>
                    반입사유<strong class="red--text">*</strong>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="editedItem.cLongReason" class="essetial_input" dense auto-grow rows="1" persistent-placeholder>
                  <template v-slot:label>
                    반입사유 상세설명<strong class="red--text">*</strong>
                  </template>
                </v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        


        <v-card flat tile v-if="editedItem.cLabel == '1'">
          <v-card-text class="pl-5 pt-0">
            <v-btn v-if="!bPolicyCheck1" class="font-weight-bold" @click="GuideDialog1 = true;"><v-icon class="mr-2">mdi-clipboard-edit-outline</v-icon>최신 OS 및 백신 설치의무 안내 및 동의</v-btn>
            <v-btn v-else disabled class="font-weight-bold"><v-icon class="mr-2 mb-n1" >mdi-clipboard-edit-outline</v-icon>최신 OS 및 백신 설치의무 안내 및 동의(동의)</v-btn>
          </v-card-text>
          <v-card-text class="pl-5 pt-0 mb-10">
            <v-btn v-if="!bPolicyCheck2" class="font-weight-bold" @click="GuideDialog2 = true;"><v-icon class="mr-2">mdi-clipboard-edit-outline</v-icon>추가 보안 서약</v-btn>
            <v-btn v-else disabled class="font-weight-bold"><v-icon class="mr-2 mb-n1" >mdi-clipboard-edit-outline</v-icon>추가 보안 서약(동의)</v-btn>
          </v-card-text>
          <v-divider class="ml-2 mr-2"></v-divider>
          <v-toolbar dense flat color="white">
            <v-toolbar-title class="grey--text text--darken-3">
              <v-icon class="mr-2">mdi-truck-delivery</v-icon>물품정보
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="AddRow(editedItem.cLabel);" class="font-weight-bold" small dark width="70px"><v-icon small class="mr-1">mdi-plus</v-icon><div class="text-caption">추가</div></v-btn>
          </v-toolbar>
          <v-card-text>
            <div>※ {{$store.state.CustomInfo.SiteNm}} 표준OS가 아닌 경우 EP센터 점검 후 사용이 가능하며, 허위로 OS를 선택하여 신청한 경우 허위 정보 제출로 산업 보안 규정에 의거하여 위규 처리 될 수 있습니다. </div>
          </v-card-text>
          <v-divider class="ml-2 mr-2"></v-divider>
          <v-card-text>
            <v-data-table
              :items="zCorCarryItemInfo"
              :headers="headers1"
              :hide-default-footer="true">
              <template v-slot:header.cComEquipNm="{ }">
                <span>제조사/모델<strong class="ml-1 red--text">*</strong></span>
              </template>
              <template v-slot:header.cOsNm="{ }">
                <span>OS<strong class="ml-1 red--text">*</strong></span>
              </template>
              <template v-slot:header.cSerialNum="{ }">
                <span>Serial No.<strong class="ml-1 red--text">*</strong></span>
              </template>
              <template v-slot:header.cMaxAddr="{ }">
                <span>Mac Address</span>
              </template>
            <template v-slot:item.cComEquipNm="{ item }">
              <v-text-field v-model="item.cComEquipNm" class="essetial_input" persistent-placeholder></v-text-field>
            </template>
            <template v-slot:item.cOsNm="{ item }">
              <v-text-field v-model="item.cOsNm" class="essetial_input" persistent-placeholder></v-text-field>
            </template>
            <template v-slot:item.cSerialNum="{ item }">
              <v-text-field v-model="item.cSerialNum" class="essetial_input" persistent-placeholder></v-text-field>
            </template>
            <template v-slot:item.cMaxAddr="{ item }">
              <v-text-field v-model="item.cMaxAddr" persistent-placeholder></v-text-field>
            </template>
            <template v-slot:item.cDel="{ item }">
              <v-icon @click="DelRow(item)" color="black">mdi-close</v-icon>
            </template>
              <template v-slot:no-data>
                <div class="black--text">물품정보를 입력하여 주세요.</div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>


        <!-- 반입물품 분류 디지털 카메라 선택 시 -->
        <v-card flat tile v-if="editedItem.cLabel == '2'">
          <v-card-text class="pl-5 pt-0 mb-10">
            <v-btn v-if="!bPolicyCheck3" class="font-weight-bold" @click="GuideDialog3 = true;"><v-icon class="mr-2">mdi-clipboard-edit-outline</v-icon>추가 보안 서약</v-btn>
            <v-btn v-else disabled class="font-weight-bold"><v-icon class="mr-2 mb-n1" >mdi-clipboard-edit-outline</v-icon>추가 보안 서약(동의)</v-btn>
          </v-card-text>
          <v-divider class="ml-2 mr-2"></v-divider>
          <v-toolbar dense flat color="white">
            <v-toolbar-title class="grey--text text--darken-3">
              <v-icon class="mr-2">mdi-truck-delivery</v-icon>물품정보
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="AddRow(editedItem.cLabel);" class="font-weight-bold" small dark width="70px"><v-icon small class="mr-1">mdi-plus</v-icon><div class="text-caption">추가</div></v-btn>
          </v-toolbar>
          <v-card-text>
            <div>※ {{$store.state.CustomInfo.SiteNm}} 표준OS가 아닌 경우 EP센터 점검 후 사용이 가능하며, 허위로 OS를 선택하여 신청한 경우 허위 정보 제출로 산업 보안 규정에 의거하여 위규 처리 될 수 있습니다. </div>
          </v-card-text>
          <v-divider class="ml-2 mr-2"></v-divider>
          <v-card-text>
            <v-data-table
              :items="zCorCarryItemInfo"
              :headers="headers2"
              :hide-default-footer="true">
              <template v-slot:header.cCarmeraNm="{ }">
                <span>제조사/모델<strong class="ml-1 red--text">*</strong></span>
              </template>
              <template v-slot:header.cCapacity="{ }">
                <span>용량<strong class="ml-1 red--text">*</strong></span>
              </template>
              <template v-slot:header.cSerialNum="{ }">
                <span>Serial No.<strong class="ml-1 red--text">*</strong></span>
              </template>
              <template v-slot:header.cStickerZone="{ }">
                <span>스티커 배부 장소<strong class="ml-1 red--text">*</strong></span>
              </template>
              <template v-slot:header.cFileId="{ }">
                <span>Serial No. 사진첨부<strong class="ml-1 red--text">*</strong></span>
              </template>
              <template v-slot:item.cCarmeraNm="{ item }">
                <v-text-field v-model="item.cCarmeraNm" class="essetial_input" persistent-placeholder></v-text-field>
              </template>
              <template v-slot:item.cCapacity="{ item }">
                <v-text-field v-model="item.cCapacity" class="essetial_input" persistent-placeholder></v-text-field>
              </template>
              <template v-slot:item.cSerialNum="{ item }">
                <v-text-field v-model="item.cSerialNum" class="essetial_input" persistent-placeholder></v-text-field>
              </template>
              <template v-slot:item.cStickerZone="{  }">
                <v-text-field value="통합보안실" disabled persistent-placeholder></v-text-field>
              </template>
              <template v-slot:item.cFileId="{ item,index }">
                <v-file-input
                  v-on:change="onSelFile(item.NowSelFile,index)"
                  v-model="item.NowSelFile"
                  style="max-width:200px"
                  accept="image/png"
                  :placeholder="item.cFileNm"
                  dense
                  class="essetial_input"
                ></v-file-input>
              </template>
              <template v-slot:item.cDel="{ item }">
                <v-icon @click="DelRow(item)" color="black">mdi-close</v-icon>
              </template>
              <template v-slot:no-data>
                <div class="black--text">물품정보를 입력하여 주세요.</div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>


        <!-- 반입물품 분류 지입자재 선택 시 -->
        <v-card flat tile v-if="editedItem.cLabel == '3'">
          <v-card-text class="pl-5 pt-0 mb-10">
            <v-btn v-if="!bPolicyCheck4" class="font-weight-bold" @click="GuideDialog4 = true;"><v-icon class="mr-2">mdi-clipboard-edit-outline</v-icon>지입자재 안내 및 동의서</v-btn>
            <v-btn v-else disabled class="font-weight-bold"><v-icon class="mr-2 mb-n1" >mdi-clipboard-edit-outline</v-icon>지입자재 안내 및 동의서(동의)</v-btn>
          </v-card-text>
          <v-divider class="ml-2 mr-2"></v-divider>
          <v-toolbar dense flat color="white">
            <v-toolbar-title class="grey--text text--darken-3">
              <v-icon class="mr-2">mdi-truck-delivery</v-icon>물품정보
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="AddRow(editedItem.cLabel);" class="font-weight-bold" small dark width="70px"><v-icon small class="mr-1">mdi-plus</v-icon><div class="text-caption">추가</div></v-btn>
          </v-toolbar>
          <v-card-text>
            <div>
              ※ 전산기기(노트북, 데스크톱)는 반입물품 분류를 전산기기로 선택 후 신청 바랍니다.
              물품 입력 시 정확하게 기입하시기 바랍니다. 예) 스마트폰(X) -> 갤럭시S21(O), 펌프(X) -> 모노펌프 회색 1M(O)
            </div>
          </v-card-text>
          <v-divider class="ml-2 mr-2"></v-divider>
          <v-card-text>
            <v-data-table
              :items="zCorCarryItemInfo"
              :headers="headers3"
              :hide-default-footer="true">
              <template v-slot:header.cPaperMatNm="{ }">
                <span>품명<strong class="ml-1 red--text">*</strong></span>
              </template>
              <template v-slot:header.cSerialNum="{ }">
                <span>Serial No.<strong class="ml-1 red--text">*</strong></span>
              </template>
              <template v-slot:header.cQuantity="{ }">
                <span>반입수량<strong class="ml-1 red--text">*</strong></span>
              </template>
              <template v-slot:header.cUnit="{ }">
                <div>단위<strong class="ml-1 red--text">*</strong></div>
              </template>

              <template v-slot:item.cPaperMatNm="{ item }">
                <v-text-field v-model="item.cPaperMatNm" class="essetial_input" persistent-placeholder></v-text-field>
              </template>
              <template v-slot:item.cSerialNum="{ item }">
                <v-text-field v-model="item.cSerialNum" class="essetial_input" persistent-placeholder></v-text-field>
              </template>
              <template v-slot:item.cQuantity="{ item }">
                <v-text-field v-model="item.cQuantity" type="number" hint="숫자만 입력하세요." class="essetial_input" persistent-placeholder></v-text-field>
              </template>

              <template v-slot:item.cUnit="{ item }">
                <div style="max-width:170px;">
                  <v-select
                    v-model="item.cUnit"
                    :items="zCarryUnit"
                    v-if="item.cUnit != '13'"
                    class="essetial_input"
                  ></v-select>
                  <v-text-field
                    v-model="item.cUnitDirect"
                    v-if="item.cUnit == '13'"
                    @click:append="item.cUnit = '1';item.cUnitDirect = ''"
                    class="essetial_input"
                    append-icon="refresh"
                    persistent-placeholder
                  ></v-text-field>
                </div>
              </template>
              <template v-slot:item.cDel="{ item }">
                <v-icon @click="DelRow(item)" color="black">mdi-close</v-icon>
              </template>
              <template v-slot:no-data>
                <div class="black--text">물품정보를 입력하여 주세요.</div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>

        <v-divider class="ma-4 mb-0"></v-divider>
        <v-card-text align="right" class="pb-3 pt-3">
          <v-btn @click="dialog = false;" width="90px" text class="mr-2"><v-icon class="mr-1">mdi-close</v-icon>닫기</v-btn>
          <v-btn @click="SetCorCarryLog()" width="90px" dark class="ml-2"><v-icon class="mr-1">save</v-icon>저장</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>


    <!-- 전산기기 선택 > 최신 OS 및 백신 설치의무 안내 및 동의 내용 -->
    <v-dialog v-model="GuideDialog1" max-width="600" persistent>
      <v-card flat tile>
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="font-weight-bold">
            최신 OS 및 백신 설치의무 안내 및 동의
          </v-toolbar-title>
        </v-toolbar>
        <v-divider class="ml-4 mr-4"></v-divider>
        <v-card-text class="pr-4 pl-4 pb-6 pt-6 mt-2">
          <div class="mb-3 black--text">전산기기 반입신청 품목에 대해서는 {{$store.state.CustomInfo.SiteNm}}이(가) 정한 표준OS로 설치 된 기기이며, 최신 Windows 보안 업데이트가 실행되어야 합니다.</div>
          <div class="mb-3 black--text">또한, 아래의 Anti Virus 프로그램 중 하나의 백신 프로그램이 설치되어야만 {{$store.state.CustomInfo.SiteNm}} 내부로 반입이 가능합니다. (평가판 설치 가능)</div>
          <div class="mb-3 black--text">License를 보유하지 않은 상용 S/W의 사용은 엄격히 제한되며, 불법 S/W를 사용하여 발생하는 민/형사상의 책임은 사용자 개인에게 귀속됩니다.</div>
          <div class="mb-3 black--text">해당 절차를 통해 반입 된 전산기기는 최종 반출 시 반드시 포맷 후 반출 가능합니다.</div>
          <div class="mb-3 ml-4">- 표준 OS : Windows 10 Enterprise 1809 (Edu, home 버전은 AD Setup 불가로 사용 불가)</div>
          <div class="mb-3 ml-4">- (※ 단, 업무상 Linux/Unix, MacOS 사용 필요시 반드시 사전 협의 후 승인된 기기만 반입 가능하며, 네트워크 사용이 차단됩니다.)</div>
          <div class="mb-3 ml-4">- 허용 백신(안랩 V3, 하우리 바이로봇, Kaspersky, McAfee, Norton, Trend Micro, 360 Security)</div>
          <v-checkbox v-model="bPolicyCheck1" dense class="mt-2" color="black">
            <template v-slot:label>
              <div class="black--text">
                동의합니다.
              </div>
            </template>
          </v-checkbox>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark @click="GuideDialog1 = false;" >
            <v-icon class="mr-2">mdi-check</v-icon>확인
          </v-btn>
        </v-card-actions>
        <!-- <v-hover v-slot="{ hover }">    
          <v-card
            :elevation="hover ? 40 : 2" >
            <v-toolbar flat height=30px></v-toolbar>
            <tr>
              <td bgcolor="black" width="8px"></td>
              <td bgcolor="white" width="20px"></td>
              <td cols="4" sm="4" md="4">
                <v-card flat class="black--text" >              
                  <h3>최신 OS 및 백신 설치의무 안내 및 동의</h3>
                </v-card >
              </td>          
            </tr>
            <v-toolbar flat height=20px></v-toolbar>

            <v-card-text align="left">            
              <div class="mb-3 black--text">전산기기 반입신청 품목에 대해서는 {{$store.state.CustomInfo.SiteNm}}가 정한 표준OS로 설치 된 기기이며, 최신 Windows 보안 업데이트가 실행되어야 합니다.</div>
              <div class="mb-3 black--text">또한, 아래의 Anti Virus 프로그램 중 하나의 백신 프로그램이 설치되어야만 {{$store.state.CustomInfo.SiteNm}} 내부로 반입이 가능합니다. (평가판 설치 가능)</div>
              <div class="mb-3 black--text">License를 보유하지 않은 상용 S/W의 사용은 엄격히 제한되며, 불법 S/W를 사용하여 발생하는 민/형사상의 책임은 사용자 개인에게 귀속됩니다.</div>
              <div class="mb-3 black--text">해당 절차를 통해 반입 된 전산기기는 최종 반출 시 반드시 포맷 후 반출 가능합니다.</div>
              <div class="mb-3 ml-4">- 표준 OS : Windows 10 Enterprise 1809 (Edu, home 버전은 AD Setup 불가로 사용 불가)</div>
              <div class="mb-3 ml-4">- (※ 단, 업무상 Linux/Unix, MacOS 사용 필요시 반드시 사전 협의 후 승인된 기기만 반입 가능하며, 네트워크 사용이 차단됩니다.)</div>
              <div class="mb-3 ml-4">- 허용 백신(안랩 V3, 하우리 바이로봇, Kaspersky, McAfee, Norton, Trend Micro, 360 Security)</div>
              <v-checkbox v-model="bPolicyCheck1" dense class="mt-2" color="black">
                <template v-slot:label>
                  <div class="black--text">
                    동의합니다.
                  </div>
                </template>
              </v-checkbox>
            </v-card-text>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black darken-2" text @click="GuideDialog1 = false;" class="font-weight-bold text-subtitle-1">
              <v-icon class="mr-2">mdi-checkbox-multiple-marked-circle</v-icon>확인
            </v-btn>
            </v-card-actions>
          </v-card>    
        </v-hover> -->
      </v-card>
    </v-dialog>


    <!-- 전산기기 선택 > 추가 보안 서약 내용 -->
    <v-dialog v-model="GuideDialog2" max-width="600" persistent>
      <v-card flat tile>
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="font-weight-bold">
            추가 보안 서약
          </v-toolbar-title>
        </v-toolbar>
        <v-divider class="ml-4 mr-4"></v-divider>
        <v-card-text class="pr-4 pl-4 pb-6 pt-6 mt-2">
          <div class="mb-3 black--text">상가 본인은 {{$store.state.CustomInfo.SiteNm}}(이하 회사라 한다)을(를) 출입하는 데 허가된 목적 외 산업 보안에 위배되는 행위를 하지 않을 것이며, 회사의 허가없이 자료를 저장하지 않겠습니다.</div>
          <div class="mb-3 black--text">회사 영업비밀 등 자료의 반출이 필요한경우 사전 예약부서팀장 승인을 통하여 저장할 것이며, 반출 시 사전 승인된 자료라 할지라도 보안목적상 삭제 시에도 이의를 제기하지 않겠습니다.</div>
          <div class="mb-3 black--text">또한 회사 영업비밀 등 업무자료를 불법 저장하거나 반출 시도 時 어떠한 법적조치도 감수하겠습니다. </div>
          <v-checkbox v-model="bPolicyCheck2" dense class="mt-2" color="black">
            <template v-slot:label>
              <div class="black--text">
                동의합니다.
              </div>
            </template>
          </v-checkbox>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark @click="GuideDialog2 = false;" >
            <v-icon class="mr-2">mdi-check</v-icon>확인
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- 디지털 카메라 선택 > 추가 보안 서약 내용 -->
    <v-dialog v-model="GuideDialog3" max-width="600" persistent>
      <v-card flat tile>
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="font-weight-bold">
            추가 보안 서약
          </v-toolbar-title>
        </v-toolbar>
        <v-divider class="ml-4 mr-4"></v-divider>
        <v-card-text class="pr-4 pl-4 pb-6 pt-6 mt-2">
          <div class="mb-3 black--text">상가 본인은 {{$store.state.CustomInfo.SiteNm}}(이하 회사라 한다)를 출입하는 데 허가된 목적 외 산업 보안에 위배되는 행위를 하지 않을 것이며, 회사의 허가없이 자료를 저장하지 않겠습니다.</div>
          <div class="mb-3 black--text">회사 영업비밀 등 자료의 반출이 필요한경우 사전 예약부서팀장 승인을 통하여 저장할 것이며, 반출 시 사전 승인된 자료라 할지라도 보안목적상 삭제 시에도 이의를 제기하지 않겠습니다.</div>
          <div class="mb-3 black--text">또한 회사 영업비밀 등 업무자료를 불법 저장하거나 반출 시도 時 어떠한 법적조치도 감수하겠습니다. </div>
          <v-checkbox v-model="bPolicyCheck3" dense class="mt-2" color="black">
            <template v-slot:label>
              <div class="black--text">
                동의합니다.
              </div>
            </template>
          </v-checkbox>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark @click="GuideDialog3 = false;" >
            <v-icon class="mr-2">mdi-check</v-icon>확인
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="GuideDialog4" max-width="600" persistent>
      <v-card flat tile>
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="font-weight-bold">
            지입자재 안내 동의서
          </v-toolbar-title>
        </v-toolbar>
        <v-divider class="ml-4 mr-4"></v-divider>
        <v-card-text class="pr-4 pl-4 pb-6 pt-6 mt-2">
          <div class="mb-3 black--text">업체물품 반입신청 품목에 대해서는 업체물품 소유의 물품으로 작업 공구 가자재 Warranty 기간 내 무상교환품만 해당되며, Warranty 기간 내 발생한 교체 건은 비용발생 없이 무상교체를 진행함을 동의합니다.({{$store.state.CustomInfo.SiteNm}}에 비용을 청구하지 않는 물품)</div>
          <div class="mb-3 black--text">※ 업체물품은 협력사 또는 제 3자 소유물품으로 {{$store.state.CustomInfo.SiteNm}}가 구매대금을 지급하지 않습니다.</div>
          <v-checkbox v-model="bPolicyCheck4" dense class="mt-2" color="black">
            <template v-slot:label>
              <div class="black--text">
                동의합니다.
              </div>
            </template>
          </v-checkbox>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark @click="GuideDialog4 = false;" >
            <v-icon class="mr-2">mdi-check</v-icon>확인
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <MapDialog ref="MapDialogRef" @SetMap="SetMap"/>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import BasicInfo from "@/BasicInfo.js";
import axios from "axios";
import EventBus from "@/eventBus.js";

import IronDate from '@/components/iron28Calendar/src/IronDate4.vue';
import Util from "../Util.js";

import MapDialog from "./MapDialog.vue";

export default {
  components: {
    IronDate,
    MapDialog,
  },

  data: () => ({
    dialog : false,
    loading : false,
    GuideDialog1 : false,
    GuideDialog2 : false,
    GuideDialog3 : false,
    GuideDialog4 : false,
    bPolicyCheck1 : false,
    bPolicyCheck2 : false,
    bPolicyCheck3 : false,
    bPolicyCheck4 : false,
    iEditIndex : -1,
    sToday : new Date(),
    zCorCarryItemInfo : [],
    zMapZoneInfo : [],
    editedItem : {
      cReqId : "",
      cBizCode : "",
      cLabel : "",
      cDirLabel : "",
      cZone : "",
      cReason : "",
      cSort : "1",
      cLocal : "",
      cCorpNmKor : "",
      cCorpNmEng : "",
      cCarryDocNum : "",
      cLongReason : "",
      cCarryInDate : Util.sFormatDate(Date()),
      cCarryOutDate : Util.sFormatDate(Util.sTomorrowSel()),
      sNowSelectDate : Util.sFormatDate(Date()) + " ~ " +  Util.sFormatDate(Util.sTomorrowSel()),
    },
    headers1 : [
      { text: '제조사/모델', value: 'cComEquipNm',sortable : false},
      { text: 'OS', value: 'cOsNm',sortable : false},
      { text: 'Serial No.', value: 'cSerialNum',sortable : false},
      { text: 'Mac Address', value: 'cMaxAddr',sortable : false},
      { text: '삭제', value: 'cDel',sortable : false},
    ],
    headers2 : [
      { text: '제조사/모델', value: 'cCarmeraNm',sortable : false},
      { text: '용량', value: 'cCapacity',sortable : false},
      { text: 'Serial No.', value: 'cSerialNum',sortable : false},
      { text: '스티커 배부 장소', value: 'cStickerZone',sortable : false},
      { text: 'Serial No. 사진첨부', value: 'cFileId',sortable : false},
      { text: '삭제', value: 'cDel',sortable : false},
    ],
    headers3 : [
      { text: '품명', value: 'cPaperMatNm',sortable : false},
      { text: 'Serial No.', value: 'cSerialNum',sortable : false},
      { text: '반입수량', value: 'cQuantity',sortable : false},
      { text: '단위', value: 'cUnit',sortable : false},
      { text: '삭제', value: 'cDel',sortable : false},
    ],
  }),
  computed: {
    ...mapState(["CustomInfo","zCarryItem","zCarryUnit","zFileType","FMaxSize3"]),
  },
  methods: {
    ShowDialog(item,Index,Zone,zItemInfo){
      this.dialog = true
      this.bPolicyCheck1 = false
      this.bPolicyCheck2 = false
      this.bPolicyCheck3 = false
      this.bPolicyCheck4 = false
      this.iEditIndex = Index

      // this.editedItem = JSON.parse(JSON.stringify(item));

      this.editedItem.cLabel = item.cLabel
      this.editedItem.cReqId = item.cReqId
      this.editedItem.cBizCode = item.cBizCode
      this.editedItem.cZone = item.cZone
      this.editedItem.cLocal = item.cLocal
      this.editedItem.cCorpNmKor = item.cCorpNmKor
      this.editedItem.cCorpNmEng = item.cCorpNmEng
      this.editedItem.cReason = item.cReason
      this.editedItem.cSort = item.cSort
      this.editedItem.cLongReason = item.cLongReason
      this.editedItem.cCarryDocNum = item.cCarryDocNum

      if (this.editedItem.cSort == "2") {
        this.editedItem.cCarryOutDate = Util.sFormatDate(item.cCarryOutDate);
        this.editedItem.sNowSelectDate = Util.sFormatDate(item.cCarryOutDate);
      } else {
        this.editedItem.cCarryInDate = Util.sFormatDate(item.cCarryInDate);
        this.editedItem.cCarryOutDate = Util.sFormatDate(item.cCarryOutDate);
        this.editedItem.sNowSelectDate = this.editedItem.cCarryInDate + " ~ " +  this.editedItem.cCarryOutDate;
      }


      this.zMapZoneInfo = [];
      for (let i =0; i < Zone.length; i ++){
        this.zMapZoneInfo.push(Zone[i].cId)
      }

      if (this.editedItem.cLabel == "3") {
        for (let k =0; k < zItemInfo.length; k ++){
          let bTest = false
          for (let l =0; l < this.zCarryUnit.length; l ++){
            if (this.zCarryUnit[l].value == zItemInfo[k].cUnit) {
              bTest = true
              break
            }
          }
          if (bTest) {
            zItemInfo[k].cUnitDirect = ""
          } else {
            
            zItemInfo[k].cUnitDirect = zItemInfo[k].cUnit
            zItemInfo[k].cUnit = "13"
          }
        }
      }
      
      this.zCorCarryItemInfo = zItemInfo
      setTimeout(() => {
        var element =  document.getElementById("Top_Scroll");
        element.scrollIntoView({behavior : "smooth"})
      }, 10);      
    },

    ShowMapDialog(){
      this.$refs.MapDialogRef.ShowDialog(this.zMapZoneInfo)
    },

    SetMap(zZone,zZoneNm){
      this.zMapZoneInfo = zZone
      this.editedItem.cZone = zZoneNm
    },

    AddRow(value){
      if (value == "1"){
        this.zCorCarryItemInfo.push({cComEquipNm : "", cOsNm : "", cSerialNum : "", cMaxAddr : ""})
      } else if (value == "2") {
        this.zCorCarryItemInfo.push({cCarmeraNm : "", cCapacity : "", cSerialNum : "", cStickerZone : "", cFileId : "",cFileNm : "",NowSelFile : null})
      } else {
        this.zCorCarryItemInfo.push({cPaperMatNm : "", cSerialNum : "", cQuantity : "", cUnit : "1",cUnitDirect :""})
      }
    },

    DelRow(row) {
      let iDelIndex = this.zCorCarryItemInfo.indexOf(row);
      if (iDelIndex != -1) {  
        this.zCorCarryItemInfo.splice(iDelIndex, 1);
      }
    },

    // 미반출 시 날짜 표기를 하루로 변경하기
    DisableSelect() {
      if (this.editedItem.cSort == "2") {
        this.editedItem.cCarryOutDate = this.editedItem.cCarryInDate;
        this.editedItem.sNowSelectDate = this.editedItem.cCarryInDate;
      } else {
        this.editedItem.cCarryInDate = Util.sFormatDate(Date());
        this.editedItem.cCarryOutDate = Util.sFormatDate(Util.sTomorrowSel());
        this.editedItem.sNowSelectDate = this.editedItem.cCarryInDate + " ~ " +  this.editedItem.cCarryOutDate;
      }
    },

    overmaxperiod(value){
      EventBus.$emit("onShowMsgBox", value.sTitle,value.sMsg);
    },

    // 날짜 변경하기
    onDateRangeChange(daterange){
      this.editedItem.cCarryInDate = Util.sFormatDate(daterange.startDate);
      this.editedItem.cCarryOutDate = Util.sFormatDate(daterange.endDate);
      this.editedItem.sNowSelectDate = this.editedItem.cCarryInDate + " ~ " +  this.editedItem.cCarryOutDate;
      this.editedItem.cSort == "2"?this.editedItem.sNowSelectDate = this.editedItem.cCarryInDate:this.editedItem.sNowSelectDate = this.editedItem.cCarryInDate + " ~ " +  this.editedItem.cCarryOutDate
    },

    bSendSvrFile(NowSelFile){
      var d = new Date();
      var Year = d.getFullYear(); 
      var fileName = NowSelFile.name;
      var Extend = Util.getExtension(fileName).toUpperCase();
      var sFileTypeId = Util.sGetId(Util.sGetFileType(NowSelFile.type));
        
      let formData = new FormData();
      formData.append('uploadfile', NowSelFile);
      return new Promise((resolve) => (
        axios.post(process.env.VUE_APP_UIL_API + "UploadFile?PublicFile=Y&Year="+Year+"&FileNm="+fileName+"&Extend="+Extend+"&MimeType="+NowSelFile.type+"&Size="+NowSelFile.size+"&FileTypeId="+sFileTypeId+"&SiteId="+this.$store.state.CustomInfo.SiteId,
                formData,
                {
                headers: {
                  // "Authorization": this.CustomInfo.Token,
                  'Content-Type': 'multipart/form-data',
                }
              }
            )
            .then(res => {
              resolve(res);
            })
            .catch(err =>{
              resolve(null);
              EventBus.$emit("onShowMsg",true, "File Send Error-Network Error!" + err)
          })
      ));
    },

    // 업체물품 반입 신청하기
    async SetCorCarryLog(){
      if (this.editedItem.cReason == "" || this.editedItem.cLongReason == "") {
        EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "반입사유 및 상세설명을 입력하여 주세요.");
        return
      }

      if (this.editedItem.cLabel == "1" && this.bPolicyCheck1 == false) {
        EventBus.$emit("onShowMsgBox","최신 OS 및 백신설치의무에 대한 동의가 필요합니다.", "최신 OS 및 백신설치의무 안내 및 동의를 읽으신 후 동의하기를 선택하여 주세요.");
        return
      }
      if (this.editedItem.cLabel == "1" && this.bPolicyCheck2 == false) {
        EventBus.$emit("onShowMsgBox","추가 보안 서약에 대한 동의가 필요합니다.", "추가 보안 서약를 읽으신 후 동의하기를 선택하여 주세요.");
        return
      }
      if (this.editedItem.cLabel == "2" && this.bPolicyCheck3 == false) {
        EventBus.$emit("onShowMsgBox","추가 보안 서약에 대한 동의가 필요합니다.", "추가 보안 서약를 읽으신 후 동의하기를 선택하여 주세요.");
        return
      }
      if (this.editedItem.cLabel == "3" && this.bPolicyCheck4 == false) {
        EventBus.$emit("onShowMsgBox","지입자재 안내 동의에 대한 동의가 필요합니다.", "지입자재 안내 동의서를 읽으신 후 동의하기를 선택하여 주세요.");
        return
      }

      if (this.editedItem.cLabel == "1" && this.zCorCarryItemInfo.length == 0) {
        EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "전산기기 물품을 등록하여 주세요.");
        return
      }

      if (this.editedItem.cLabel == "2" && this.zCorCarryItemInfo.length == 0) {
        EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "디지털카메라 물품을 등록하여 주세요.");
        return
      }

      if (this.editedItem.cLabel == "3" && this.zCorCarryItemInfo.length == 0) {
        EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "디지털카메라 물품을 등록하여 주세요.");
        return
      }

      let j = 0;
      for (j in this.zCorCarryItemInfo) {
        if (this.zCorCarryItemInfo[j].cSerialNum == "") {
          EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "Serial No. 항목을 입력하여 주세요.");
          return
        } 
        if (this.editedItem.cLabel == "1" && this.zCorCarryItemInfo[j].cComEquipNm == "") {
          EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "제조사/모델 항목을 입력하여 주세요.");
          return
        } 
        if (this.editedItem.cLabel == "1" && this.zCorCarryItemInfo[j].cOsNm == "") {
          EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "OS 항목을 입력하여 주세요.");
          return
        } 
        if (this.editedItem.cLabel == "2" && this.zCorCarryItemInfo[j].cCarmeraNm == "") {
          EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "제조사/모델 항목을 입력하여 주세요.");
          return
        } 
        if (this.editedItem.cLabel == "2" && this.zCorCarryItemInfo[j].cCapacity == "") {
          EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "용량 항목을 입력하여 주세요.");
          return
        } 
        if (this.editedItem.cLabel == "2" && (this.zCorCarryItemInfo[j].cFileId == "" && this.zCorCarryItemInfo[j].NowSelFile == undefined)) {
          EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "파일을 첨부하여 주세요.");
          return
        } 
        if (this.editedItem.cLabel == "3" && this.zCorCarryItemInfo[j].cPaperMatNm == "") {
          EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "품명을 입력하여 주세요.");
          return
        } 
        if (this.editedItem.cLabel == "3" && this.zCorCarryItemInfo[j].cQuantity == "") {
          EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "반입수량을 입력하여 주세요.");
          return
        } 
        if (this.editedItem.cLabel == "3" && this.zCorCarryItemInfo[j].cUnit == "") {
          EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "단위를 선택하여 주세요.");
          return
        }
        // if (this.editedItem.cLabel == "3" && this.zCorCarryItem[j].cUnit == "13" && this.zCorCarryItem[j].cUnitDirect == "") {
        if (this.editedItem.cLabel == "3" && this.zCorCarryItemInfo[j].cUnit == "13" && this.zCorCarryItemInfo[j].cUnitDirect == "") {
          EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "단위를 입력하여 주세요.");
          return
        }
        if (this.editedItem.cLabel == "3" && this.zCorCarryItemInfo[j].cUnitDirect.length > 20) {
          EventBus.$emit("onShowMsgBox","단위를 직접 입력 하실 때 20자 넘게 입력하셨습니다.",  "띄어쓰기를 포함하여 최대 20자까지 입력이 가능합니다.");
          return
        }
      }

      if (this.editedItem.cLabel == "2") {
        this.loading = true;
        let i = 0;
        for (i in this.zCorCarryItemInfo) {
          if (this.zCorCarryItemInfo[i].NowSelFile != null) {
            var res = await this.bSendSvrFile(this.zCorCarryItemInfo[i].NowSelFile);
            if (res.data.ResultCd == "00") {
              this.zCorCarryItemInfo[i].cFileId = res.data.FileId;
            } else {
              EventBus.$emit("onShowMsg",true, "File Send Error-Network Error!");
              return;
            }        
          }
        }
        this.loading = false;
      }

      if (this.editedItem.cLabel == "3") {
        let i = 0
        for (i in this.zCorCarryItemInfo) {
          if (this.zCorCarryItemInfo[i].cUnit == "13") {
            this.zCorCarryItemInfo[i].cUnit = this.zCorCarryItemInfo[i].cUnitDirect
          }
        }
      }

      var posData = {
        ReqId : this.editedItem.cReqId,
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        CorpId : this.CustomInfo.CorpId,
        Label : this.editedItem.cLabel,
        Zone : this.editedItem.cZone,
        Reason : this.editedItem.cReason,
        LongReason : this.editedItem.cLongReason,
        Sort : this.editedItem.cSort,
        CarryInDate : this.editedItem.cCarryInDate,
        CarryOutDate : this.editedItem.cCarryOutDate,
        MapTreeInfo : Util.ChangeArray(this.zMapZoneInfo),
        CorCarryItem : this.zCorCarryItemInfo,
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "SetCorCarryLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "00") {
            this.dialog = false;
            this.$emit("ChangeCorCarryLog",this.editedItem,this.iEditIndex)
            EventBus.$emit("onShowMsg",false,  "수정이 완료되었습니다.");
          } else if (res.data.ResultCd == "02"){
            EventBus.$emit("onShowMsgBox","삭제되었거나 승인된 사항입니다.", "초기화 버튼을 눌러서 상태를 확인해 주세요.");
            this.dialog = false;
          } else if (res.data.ResultCd == "55") {
            EventBus.$emit("onShowMsgBox","출입 정지 기간 중입니다.", res.data.Msg);
          } else {
            this.dialog = false;
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onFileBus", true,""+err);
        });
    },

    // 파일 선택시 파일 경로 및 데이터 가져오기
    onSelFile(NowSelFile,index) {
      let bFileType = false

      if (NowSelFile != null)  {
        if (NowSelFile.size > this.FMaxSize3)  {
          setTimeout(() => {
            this.zCorCarryItemInfo[index].NowSelFile = null;
          }, 300);
          EventBus.$emit("onShowMsgBox","첨부하신 파일의 용량의 크기를 확인하여 주세요.","첨부하실수 있는 파일의 크기는 최대 10MB까지 입니다.");
          return
        }

        for ( let i in this.zFileType) {
          if (this.zFileType[i] == NowSelFile.type) {
            bFileType =  true;
            break
          }
        }
      } else {
        bFileType = true
      }

      if (!bFileType) {
        setTimeout(() => {
          this.NowSelFile = null;
        }, 300);
        EventBus.$emit("onShowMsgBox","첨부하신 파일의 형식을 확인하여 주세요.","첨부하실수 있는 파일의 형식은 JPG,JPEG,PNG,GIF 입니다.");
        return
      }

      const reader = new FileReader
      try {
        reader.readAsDataURL(NowSelFile)        
      }
      catch (error) {
        EventBus.$emit("onFileBus", true,""+error);
        // EventBus.$emit("onShowMsg", true,""+error);
        
      }
    },
  }
}
</script>
